import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TaskCaseService } from '../../services/taskCase.service';
import { ActivatedRoute } from '@angular/router';
import { CasesService } from 'src/app/core/services/cases.service';
import { PdfResumeCaseService } from '../../services/pdf-resume-case.service';
import * as moment from 'moment';
import { IUnit } from 'src/app/modules/unit/interfaces/unit.interface';

enum Texts {
  unit = 'Unidad',
  type = 'Tipo de caso',
  status = 'Estado',
  number = 'Número de caso',
  asignTo = 'Responsable',
  date = 'Fecha de creación',
  description = 'Descripción del caso',
  observation = 'Observación del gerente',
  remitido = 'Remitido de',
  fechaDelReporte = 'Fecha del Reporte',
  numeroDeIdentificacion = 'Número de Identificación',
  nivelDeRiesgo = 'Nivel de Riesgo',
  nivelSocioEconomico = 'Nivel Socioeconómico',
  nuras = 'Número RAS',
}

enum status {
  initial = 'Sin comenzar',
  running = 'En ejecución',
  tobeApproved = 'Por aprobar',
  toFinalize = 'Por finalizar',
  archived = 'Archivado',
  pending = 'Pendiente',
}
enum statusTask {
  pending = 'Sin comenzar',
  running = 'En ejecución',
  finished = 'Por finalizar',
}
@Component({
  selector: 'resumeCasePreview',
  templateUrl: './resumeCasePreview.component.html',
  styleUrls: ['./resumeCasePreview.component.scss'],
})
export class ResumeCasePreviewComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ResumeCasePreviewComponent>,
    public readonly taskCaseService: TaskCaseService,
    private readonly route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly pdfResumeCaseService: PdfResumeCaseService
  ) {
    this.setInformation(this.data.iCase);
  }
  id;
  inf;
  arr;
  ngOnInit() {
    this.getTaskByCaseId();
  }
  close() {
    this.dialogRef.close();
  }
  printPdf() {
    this.pdfResumeCaseService.createPDF(
      this.taskData,
      this.inf,
      this.data.iCase,
      this.arr
    );
  }

  async getTaskByCaseId() {
    await this.taskCaseService
      .getTaskByCaseId(this.data.id)
      .subscribe((res) => {
        this.createArrayTask(res);
      });
  }
  taskData = [];
  firstBlock: any[];
  secondBlock: any[];
  thirdBlock: any[];
  information;
  statusTask = statusTask;
  createArrayTask(taskCase) {
    taskCase.forEach((task) => {
      let valueOfTask = { valuesObject: [] };
      if (task.data) {
        const keys = Object.keys(task.data);
        for (let value in keys) {
          valueOfTask.valuesObject.push({
            value: task.data[keys[value]],
            key: keys[value],
          });
        }
        task['valuesObject'] = this.saveRecordUpdateTaskCase(task);
        task['valuesObject2'] = this.saveRecordUpdateTaskCase(task);
      }
    });
    this.taskData = taskCase;

    let half = this.thirdBlock.slice(0, this.thirdBlock.length / 2);
    let half2 = this.thirdBlock.slice(this.thirdBlock.length / 2);
    this.firstBlock = [...this.firstBlock, ...half];
    this.secondBlock = [...this.secondBlock, ...half2];

    let columnsInfo = [this.firstBlock, this.secondBlock];
    let inf = [];
    let colum = { text: [] };

    for (let element of columnsInfo) {
      colum = { text: [] };
      for (let info of element) {
        colum.text.push({
          text: `${info.title}: `,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 0, 5],
        });
        colum.text.push(`${info.text} \n`);
      }
      inf.push(colum);
    }
    let arr = [];
    for (let task of this.taskData) {
      arr.push({
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 5,
            x2: 520, // Ancho de la línea
            y2: 5,
            lineWidth: 1, // Grosor de la línea
            lineColor: '#000000', // Color de la línea (código hexadecimal)
          },
        ],
        margin: [0, 0, 0, 10],
      });
      let text: any = [
        {
          text: `Título: `,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 5, 0],
        },
        `${task.title} \n`,
        {
          text: `Descricion: `,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 5, 0],
        },
        `${task.description} \n`,
        {
          text: `Estado: `,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 5, 0],
        },
        `${statusTask[task.status]} \n`,
        {
          text: `Creado: `,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 5, 0],
        },
        `${moment(task.createdAt).format('d/MM/yyyy h:mm a	 HH:mm')} \n`,
        {
          text: `Actualizado: `,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 5, 0],
        },
        `${moment(task.updatedAt).format('d/MM/yyyy h:mm a	 HH:mm')} \n`,
        {
          text: `Observación: `,
          fontSize: 12,
          bold: true,
          margin: [0, 0, 5, 0],
        },
        `${task.observations} \n`,
      ];
      let x;
      if (task.valuesObject) {
        x = task.valuesObject.dataTable;
        if (task.valuesObject.dataTable) {
          let info = [];
          for (let d of task.valuesObject.dataTable[0]) {
            info.push({
              text: `${d}: `,
              fontSize: 7,
              bold: true,
            });
          }
          task.valuesObject.dataTable.splice(0, 1, info);
          // text.push({
          //   table: {
          //     // headerRows: 1,
          //     body: newTask.valuesObject.dataTable,
          //   },
          // });
        }
        if (task.valuesObject.data) {
          for (let sentence of task.valuesObject.data) {
            text.push({
              text: `${sentence.key}: `,
              fontSize: 12,
              bold: true,
              margin: [0, 0, 0, 5],
            });
            text.push(`${sentence.value} \n`);
          }
        }
      }
      arr.push({
        text,
      });
      if (x) {
        arr.push({
          style: 'tableStyle',
          table: {
            headerRows: 1,
            body: x,
          },
        });
      }
    }
    this.inf = inf;
    this.arr = arr;
  }

  //tienes que usar la funcion de abajo para tomar los datos de los campos y
  // funcionar como lo hace la funcion de arriba

  setInformation(information: any) {
    this.information = information;

    this.firstBlock = [
      {
        title: Texts.unit,
        text: this.data.unit as IUnit,
      },
      {
        title: Texts.type,
        text: information.caseType.name,
      },
      {
        title: Texts.status,
        text: status[information.status],
      },
    ];

    this.secondBlock = [
      {
        title: Texts.number,
        text: information.gai,
      },
      {
        title: Texts.asignTo,
        text: information.assigned?.fullname || 'Requiere usuario *',
      },
      {
        title: Texts.date,
        text: moment(information.createdAt).format('DD/MM/YYYY'),
      },
    ];

    this.thirdBlock = [
      {
        title: Texts.description,
        text: information.description,
        expanded: false,
      },
      {
        title: Texts.date,
        text: moment(information.updatedAt).format('DD/MM/YYYY'),
      },
    ];

    // Only if is ras case
    if (information.caseType.name == 'RAS') {
      this.firstBlock.push({
        title: Texts.fechaDelReporte,
        text: moment(
          information.additionalInformation.fecha_del_reporte
        ).format('DD/MM/YYYY'),
      });
      this.secondBlock.push({
        title: Texts.numeroDeIdentificacion,
        text: information.additionalInformation.numero_de_identificacion,
      });
      this.thirdBlock.push({
        title: Texts.nivelDeRiesgo,
        text: information.additionalInformation.nivel_de_riesgo,
      });
      this.thirdBlock.push({
        title: Texts.nivelSocioEconomico,
        text: information.additionalInformation.levelEcon,
      });
      this.thirdBlock.push({
        title: Texts.nuras,
        text: information.numberRas,
        expanded: false,
      });
    }

    // this.thirdBlock.push({
    //   title: Texts.observation,
    //   text: information.commentReview,
    //   expanded: false,
    // });
  }
  //////////////////////////////////////////////////
  //  Switch que dice que componente del caso es  //
  /////////////////////////////////////////////////
  saveRecordUpdateTaskCase(taskCase) {
    //////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////
    let data = [];
    let dataTable;
    let keys: any;
    let status: any;
    let llaves;
    switch (taskCase.task.component) {
      case 'DatosMigratorios':
        keys = Object.keys(taskCase.data[0]);
        status = {
          pasaporte: 'Pasaporte',
          tipo_movimiento: 'Movimiento',
          aerolinea: 'Aerolinea',
          tipo_visa: 'Visa',
          sello: 'Sello',
          fecha_tramite: 'Fecha',
          pais_ciudad_origen: 'Origen',
          numero_vuelo: 'Vuelo',
          pais_ciudad_destino: 'Destino',
        };
        llaves = Object.values(status);
        dataTable = [llaves];
        for (let el of taskCase.data) {
          let register = [];
          for (let value in keys) {
            register.push(el[keys[value]]);
          }
          dataTable.push(register);
        }

        break;
      case 'DatosResidenciales':
        keys = Object.keys(taskCase.data);
        status = {
          calle: 'Calle',
          casa_edificio: 'N° Casa/Nombre edificio',
          avenida: 'Avenida',
          piso_apartamento: 'Piso/N° Apartamento',
          urbanizacion: 'Urbanización',
          parroquia: 'Parroquia',
          municipio: 'Municipio',
          ciudad: 'Ciudad',
          estado: 'Estado',
          referencia_direccion: 'Referencia de dirección',
        };
        llaves = Object.keys(taskCase.status);

        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'DireccionAntecedentesLaborales':
        keys = Object.keys(taskCase.data);
        status = {
          nombre_empresa: 'Nombre de la empresa',
          rif: 'RIF de la empresa',
          calle: 'Calle',
          casa_edificio: 'N° Casa/Nombre edificio',
          avenida: 'Avenida',
          piso_apartamento: 'Piso/N° Apartamento',
          urbanizacion: 'Urbanización',
          parroquia: 'Parroquia',
          municipio: 'Municipio',
          ciudad: 'Ciudad',
          estado: 'Estado',
          referencia_direccion: 'Referencia de dirección',
        };
        llaves = Object.keys(taskCase.status);

        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'DatosFiliatorios':
        keys = Object.keys(taskCase.data);
        status = {
          descripcion: 'NM código de usuario (NM, CT)',
          nombre_empresa: 'Nombre de la empresa',
          rif: 'RIF de la empresa',
          tipo_persona: 'Tipo persona',
          razon_social: 'Razón social',
          cedula: 'Cédula',
          nombre: 'Nombres y apellidos',
          telefono: 'Télefonos',
          direccion: 'Dirección',
          direccion_laboral: 'Dirección laboral',
          otras_direcciones_BDV: 'Otras direcciones en BDV',
          oficina_tutora: 'Oficina tutora',
          cuentas_BDV: 'Cuentas BDV',
          saldo: 'Saldo',
          correo: 'Correo',
          referencia_personal_BDV: 'Referencia personal BDV',
        };
        llaves = Object.keys(taskCase.status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'InformacionEmpleados':
        keys = Object.keys(taskCase.data);
        status = {
          codigo_usuario: 'NM código de usuario (NM, CT)',
          cedula: 'Cédula de identidad',
          nombres_apellidos: 'Nombres y apellidos',
          cargo: 'Cargo',
          fecha_ingreso: 'Fecha de ingreso',
          fecha_egreso: 'Fecha de egreso',
          fecha_activacion: 'Fecha de activación',
          supervisor_inmediato: 'Supervisor inmediato',
          estado: 'Estado',
          departamento_agencia: 'Departamento o agencia',
        };
        llaves = Object.keys(taskCase.status);

        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'CuentasOtrosBancos':
        keys = Object.keys(taskCase.data.table[0]);
        status = {
          banco: 'Banco',
          numero_cuenta: 'N° de cuenta',
        };
        llaves = Object.values(status);
        dataTable = [llaves];
        for (let el of taskCase.data.table[0]) {
          let register = [];
          for (let value in keys) {
            register.push(el[keys[value]]);
          }
          dataTable.push(register);
        }
        break;
      case 'InteraccionRedesSociales':
        keys = Object.keys(taskCase.data[0]);
        status = {
          red_social: 'Red social',
          nombre_cuenta: 'Nombre cuenta',
        };
        llaves = Object.values(status);
        dataTable = [llaves];
        for (let el of taskCase.data) {
          let register = [];
          for (let value in keys) {
            register.push(el[keys[value]]);
          }
          dataTable.push(register);
        }

        break;
      case 'RastreoMovimientosBancarios':
        keys = Object.keys(taskCase.data[0]);
        status = {
          cuenta_origen: 'Cuenta origen',
          cuenta_destino: 'Cuenta destino',
          monto: 'Monto',
          fecha: 'Fecha',
        };
        llaves = Object.values(status);
        dataTable = [llaves];
        for (let el of taskCase.data) {
          let register = [];
          for (let value in keys) {
            register.push(el[keys[value]]);
          }
          dataTable.push(register);
        }
        break;
      case 'ReporteDelitosInformaticos':
        keys = Object.keys(taskCase.data);
        status = {
          numero_denuncia: 'N° de denuncia',
          fecha_denuncia: 'Fecha de la denuncia',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'RegistrarRelacionMontosSalvados':
        keys = Object.keys(taskCase.data[0]);
        status = {
          datos_cliente: 'Cliente',
          montos_salvados: 'Montos salvados',
          cuenta_bancaria: 'Cuenta bancaria',
          producto_afectado: 'Cuenta destino',
          monto_reclamado: 'Monto reclamado',
          monto_retenido: 'Cuenta retenido',
          monto_recuperado: 'Cuenta recuperado',
        };
        llaves = Object.values(status);
        dataTable = [llaves];
        for (let el of taskCase.data) {
          let register = [];
          for (let value in keys) {
            register.push(el[keys[value]]);
          }
          dataTable.push(register);
        }

        break;
      case 'PersonalInternoInvolucrado':
        keys = Object.keys(taskCase.data);

        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: keys[value],
          });
        }

        break;
      case 'EvaluacionInicialCaso':
        keys = Object.keys(taskCase.data);
        status = {
          accion_autorizada: 'Acción autorizada',
          descripcion: 'Descripción',
          nombre: 'Nombre',
          cargo: 'Cargo',
          NM: 'NM',
        };
        llaves = Object.keys(status);

        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'ContactoGerente':
        keys = Object.keys(taskCase.data);
        status = {
          accion_autorizada: 'Acción autorizada',
        };
        llaves = Object.keys(status);

        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }

        break;
      case 'SuministroInformacion':
        keys = Object.keys(taskCase.data);
        status = {
          fecha_solicitud: 'Fecha de solictud',
          numero_solicitud: 'N° de solicitud',
          fecha_procesado: 'Fecha de procesado',
          fecha_enviado: 'Fecha de enviado',
          ente_solicita: 'Ente que solicita',
          direccion_carreo: 'Dirección de correo de ente que solicita',
          descripcion_solicitud: 'Descripción de la solicitud',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'evaluacionPesquisa':
        keys = Object.keys(taskCase.data);
        status = {
          involucrado: 'Personal interno involucrado',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'OrigenAsignacionCasoInvestigacion':
        delete taskCase.data.check;
        keys = Object.keys(taskCase.data);
        status = {
          codigo_agencia: 'Código y agencia involucrada',
          sake: 'Sake',
          ci_empleado: 'C.I. Empleado, NM',
          empleado: 'Empleado involucrado',
          cargo: 'Cargo',
          cliente: 'Nombre del cliente afectado',
          ci_cliente: 'C.I./RIF afectado',
          cuenta: 'Cuenta afectada',
          involucrado: 'Involucrado externo',
          ci_involucrado: 'C.I./RIF Involucrado externo',
          denuncia: 'Denuncia',
          fecha_evento: 'Fecha de alerta',
          tipo_caso: 'Tipo de caso',
          monto_riesgo: 'Monto en riesgo',
          monto_recuperado: 'Monto recuperado',
          descripcion: 'Descripción',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'SolicitudRecaudos':
        keys = Object.keys(taskCase.data);
        status = {
          origen_solicitud: 'Origen de la solicitud',
          fecha_solicitud: 'Fecha de la solicitud',
          acta_analisis: 'Acta de análisis',
          denuncia_policial: 'Denuncia policial',
          carta_reclamo_cliente: 'Carta de reclamo del cliente',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }

        break;
      case 'SolicitudReintegro':
        keys = Object.keys(taskCase.data);
        status = {
          aprobado: 'Aprobación del reintegro',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'ValidacionDeDocumentos':
        ////revisar
        keys = Object.keys(taskCase.data.documentos[0]);
        status = {
          nombre: 'Documento',
          valido: 'Valido',
          comentario: 'Comentario',
        };
        llaves = Object.values(status);
        dataTable = [llaves];
        for (let el of taskCase.data.documentos) {
          let register = [];
          for (let value in keys) {
            if (el[keys[value]] === true) {
              el[keys[value]] = 'Si';
            } else if (el[keys[value]] === false) {
              el[keys[value]] = 'No';
            }
            register.push(el[keys[value]]);
          }
          dataTable.push(register);
        }
        ////revisar
        delete taskCase.data.documentos;
        keys = Object.keys(taskCase.data);
        status = {
          is: '¿Los documentos corresponden a un trabajador del banco?',
          nombre: 'Nombre y apellido', //TErminar los campos que faltan
          nm: 'NM',
          contactar_entidad_emisora:
            'Contacto a la entidad emisora del documento y solicita validación',
          comision_especialista:
            'Comisión especialista para investigación precencial en la institución emisora del documento',
          entreaga_comunucacion_interna:
            'Elabora y entrega comunicación interna el especialista, autorizado la solicitud de información',
          respuesta_entidad: 'Recibe respuesta de la entidad emisora',
          fecha1: 'Fecha contacto emisora',
          fecha2: 'Fecha comisión especialista',
          fecha3: 'Fecha entrega comunicación',
          fecha4: 'Fecha respuesta entidad',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }

        break;
      case 'CompletarDatosSolicitudAutorizacionTransacciones':
        keys = Object.keys(taskCase.data);
        status = {
          tipo_validacion: 'Tipo Validacion',
          ci_persona: 'C.I./R.I.F de la persona',
          nombre_apellido: 'Nombres y Apellidos Persona',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'VerificarTransferenciaInterbancaria':
        keys = Object.keys(taskCase.data);
        status = {
          sellos: 'Sellos',
          firma: 'Firmas del Titular',
          telefonos: 'Teléfonos',
          cuenta: 'Número de Cuenta',
          contenidoCorreo: 'Contenido del Correo de la Solicitud',
          monto: 'Monto/Saldo Disponible',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'VerificarEmisionChequeGerencia':
        keys = Object.keys(taskCase.data);
        status = {
          sellos: 'Sellos',
          firma: 'Firmas del Titular',
          telefonos: 'Teléfonos',
          cuenta: 'Número de Cuenta',
          contenidoCorreo: 'Contenido del Correo de la Solicitud',
          monto: 'Monto/Saldo Disponible',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'CrearSolicitudValidacionReferencias':
        keys = Object.keys(taskCase.data);
        status = {
          ente_solicitante: 'Ente Solicitante',
          fecha_solicitud: 'Fecha de Solicitud',
          nombre_apellido: 'Nombres y Apellidos del Solicitante',
          ci_solicitante: 'C.I. del Solicitante',
          cargo_solicitante: 'Cargo del Solicitante',
          area_labor_solicitante: 'Area donde labora el Solicitante',
          ci_a_validar: 'C.I. de la Persona a Validar',
          nombre_apellido_validar: 'Nombres y Apellidos Persona a Validar',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'CrearSolicitudAlerta':
        keys = Object.keys(taskCase.data);
        status = {
          especialista: 'Especialista que Recibe Alerta',
          id_operador: 'I.D. del Operador de Alerta',
          id_agencia: 'I.D. de la Agencia',
          descripcion: 'Descripción de la Validación Realizada',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'Pesquisa':
        keys = Object.keys(taskCase.data);
        status = {
          descripcion: 'Descripción',
          n_oficio: 'N° Oficio',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }

        break;
      case 'InformePreliminar':
        keys = Object.keys(taskCase.data);
        status = {
          descripcion: 'Descripción',
          n_oficio: 'N° Oficio',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'PersonalInternoInvolucrado':
        keys = Object.keys(taskCase.data);
        status = {
          descripcion: 'Descripción',
          nombre: 'Nombres y apellidos personal',
          cargo: 'Cargo',
          NM: 'NM',
          ci: 'C.I./RIF afectado',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'AsesoriaGerenteServicios':
        keys = Object.keys(taskCase.data);
        status = {
          descripcion: 'Descripción',
          nombre: 'Nombres y apellidos personal',
          cargo: 'Cargo',
          NM: 'NM',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'CasoRoboHurto':
        keys = Object.keys(taskCase.data[0]);
        status = {
          observacion: 'Observación',
          fecha: 'Fecha',
        };
        llaves = Object.values(status);
        dataTable = [llaves];
        for (let el of taskCase.data) {
          let register = [];
          for (let value in keys) {
            register.push(el[keys[value]]);
          }
          dataTable.push(register);
        }
        break;
      case 'ElevaAdministraciónSeguros':
        keys = Object.keys(taskCase.data[0]);
        status = {
          observacion: 'Observación',
          fecha: 'Fecha',
        };
        llaves = Object.values(status);
        dataTable = [llaves];
        for (let el of taskCase.data) {
          let register = [];
          for (let value in keys) {
            register.push(el[keys[value]]);
          }
          dataTable.push(register);
        }
        break;
      case 'DatosCandidato':
        keys = Object.keys(taskCase.data);
        status = {
          verificacion: 'Verificación',
          nombre: 'Nombres y Apellidos del Candidato',
          ci: 'C.I del Candidato',
          cargo: 'Cargo Candidato',
          oferta_servicio: 'Oferta Servicio',
          referencias: 'Referencias Laborales',
          soporte: 'Soporte de Titulos',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }

        break;
      case 'VerificacionSaime':
        keys = Object.keys(taskCase.data);
        status = {
          validar: 'Verificado en Saime',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'VerificacionCandidato':
        keys = Object.keys(taskCase.data);
        status = {
          tiene_cuenta: 'Tiene Cuenta en el Banco',
          validos: 'Son válidos los antecedentes laborales',
          localidad:
            'Localidad de residencia es la misma o cercana a lugar de trabajo',
          validas_referencias: 'Son válidas las referencias laborales',
          laboro: 'Laboró en el Banco anteriormente',
          soporte: 'El Soporte de los Titulos son válidos',
          figura:
            'Figura en la lista de casos de investigación de Asuntos internos',
          antecedentes: 'Tiene Antecedentes (CICPC)',
          elegible: 'Elegile',
          observaciones: 'Observaciones',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'DeterminarProcedenciaDelCaso':
        keys = Object.keys(taskCase.data);
        status = {
          observacion: 'Observación',
          existeProcedencia: 'Existe Procedencia',
          reclamosMagneticos: 'Reclamos de Medios Magnético',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }

        break;
      case 'DetalleTransaccionalDelCaso':
        keys = Object.keys(taskCase.data.tableValues[0]);
        status = {
          beneficiario: 'Beneficiario',
        };
        llaves = Object.values(status);
        dataTable = [llaves];
        for (let el of taskCase.data.documentos) {
          let register = [];
          for (let value in keys) {
            if (el[keys[value]] === true) {
              el[keys[value]] = 'Si';
            } else if (el[keys[value]] === false) {
              el[keys[value]] = 'No';
            }
            register.push(el[keys[value]]);
          }
          dataTable.push(register);
        }

        delete taskCase.data.tableValues;
        keys = Object.keys(taskCase.data);
        status = {
          numero_sake: 'Nº de Sake',
          nombre_cliente: 'Nombre Cliente',
          fecha_creacion: 'Fecha Creación',
          fecha_asignacion: 'Fecha Asignación',
          fecha_solucion: 'Fecha Solución',
          canal_utilizado: 'Canal Utilizado',
          unidad_responsable: 'Unidad Responsable',
          centro_costo: 'Centro Costo',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }

        break;
      case 'ReclamosMediosMagneticos':
        keys = Object.keys(taskCase.data);
        status = {
          nombre_cliente: 'Nombre del Cliente',
          ci_rif_pasaporte: 'CI / RIF / Pasaporte',
          numero_cuenta: 'Nº de Cuenta',
          numero_sake: 'Nº de Sake',
          fecha_inicio: 'Fecha de Inicio',
          fecha_fin: 'Fecha de Fin',
          total_monto_reclamado: 'Total Monto Reclamado',
          total_numero_tx_reclamadas: 'Total Nº TX Reclamadas',
          medio_magenetico: 'Seleccione Medio Magnetico',
          numero_medio: 'Nº Medio',
          fecha_ultimo_uso: 'Fecha último uso',
          fecha_bloqueo: 'Fecha de Bloqueo',
          monto_reclamado_atm: 'Monto Reclamado ATM',
          monto_reclamado_pos: 'Monto Reclamado POS',
          monto_reclamado_adelanto_taquilla:
            'Monto Reclamado adelanto taquilla',
          monto_reclamado_credcompra: 'Monto Reclamado credcompra',
          monto_reclamado_otras_operaciones:
            'Monto Reclamado otras operaciones',
          monto_reclamado_comisiones: 'Monto Reclamado comisiones',
          monto_salvado_atm: 'Monto Salvado ATM',
          monto_salvado_pos: 'Monto Salvado POS',
          monto_salvado_adelanto_taquilla: 'Monto Salvado adelanto taquilla',
          monto_salvado_credcompra: 'Monto Salvado credcompra',
          monto_salvado_otras_operaciones: 'Monto Salvado otras operaciones',
          monto_salvado_comisiones: 'Monto Salvado comisiones',
          monto_sujeto_desicion_atm: 'Monto Sujeto a Decisión ATM',
          monto_sujeto_desicion_pos: 'Monto Sujeto a Decisión POS',
          monto_sujeto_desicion_adelanto_taquilla:
            'Monto Sujeto a Decisión adelanto taquilla',
          monto_sujeto_desicion_credcompra:
            'Monto Sujeto a Decisión credcompra',
          monto_sujeto_desicion_otras_operaciones:
            'Monto Sujeto a Decisión otras operaciones',
          monto_sujeto_desicion_comisiones:
            'Monto Sujeto a Decisión comisiones',
          monto_numero_tx_atm: 'Número de TX ATM',
          monto_numero_tx_pos: 'Número de TX POS',
          monto_numero_tx_adelanto_taquilla: 'Número de TX adelanto taquilla',
          monto_numero_tx_credcompra: 'Número de TX credcompra',
          monto_numero_tx_otras_operaciones: 'Número de TX otras operaciones',
          monto_numero_tx_comisiones: 'Número de TX comisiones',
          descripcion_hechos: 'Descripción de los hechos',
          alerta_monitoreo: 'Alerta Monitoreo',
          gestion_alerta: 'Gestión De Alerta',
          notificacion_sms: 'Notificación SMS',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'ReclamosMediosNOMagneticos':
        keys = Object.keys(taskCase.data);
        status = {
          nombre_cliente: 'Nombre del Cliente',
          ci_rif_pasaporte: 'CI / RIF / Pasaporte',
          numero_cuenta: 'Nº de Cuenta',
          numero_sake: 'Nº de Sake',
          fecha_inicio: 'Fecha de Inicio',
          fecha_fin: 'Fecha de Fin',
          total_monto_reclamado: 'Total Monto Reclamado',
          total_numero_tx_reclamadas: 'Total Nº TX Reclamadas',
          medio_magenetico: 'Seleccione Medio Magnetico',
          numero_medio: 'Nº Medio',
          fecha_ultimo_uso: 'Fecha último uso',
          fecha_bloqueo: 'Fecha de Bloqueo',
          descripcion_hechos: 'Descripción de los hechos',
          alerta_monitoreo: 'Alerta Monitoreo',
          gestion_alerta: 'Gestión De Alerta',
          notificacion_sms: 'Notificación SMS',
          tipificacion_reclamo: 'Tipificación Identificada en el Reclamo',
          analisis_gerencia_deteccion:
            'ANÁLISIS DE LA GERENCIA DETECCIÓN Y ANÁLISIS DE FRAUDES',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'DeterminarProcedenciaFraude':
        keys = Object.keys(taskCase.data);
        status = {
          procedencia: 'Procedencia de Fraude',
          fraude: 'Hubo Fraude',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }

        break;
      case 'analyzeRas':
        keys = Object.keys(taskCase.data);
        status = {
          makeAnalysis:
            'Realizar un análisis de los casos con potencialidad de reporte. (5.1)',
          bankSystemDB:
            'Ingresar a la Base de datos del sistema bancario (5.2)',
          locateTheCustomer: 'Ubicar al cliente (5.3)',
          validateCustomerClassification:
            'Validar la clasificacion del cliente (5.4)',
          customerActivity:
            'Revisa datos complementarios y actividad del cliente (5.5)',
          otherAccounts:
            'Verifica si el cliente, adicional a su cuenta principal, está autorizado al manejo y uso de otras cuentas. (5.6)',
          analyzeAccounts:
            'Analiza las cuentas de origen de fondos y realiza una evaluación (5.7)',
          status: 'Calificar la alerta',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'personInvolvedRas':
        keys = Object.keys(taskCase.data.otherPerson[0]);
        status = {
          document: 'Documento',
        };
        llaves = Object.values(status);
        dataTable = [llaves];
        for (let el of taskCase.data.otherPerson[0]) {
          let register = [];
          for (let value in keys) {
            if (el[keys[value]] === true) {
              el[keys[value]] = 'Si';
            } else if (el[keys[value]] === false) {
              el[keys[value]] = 'No';
            }
            register.push(el[keys[value]]);
          }
          dataTable.push(register);
        }
        delete taskCase.data.otherPerson;
        keys = Object.keys(taskCase.data);
        status = {
          names: 'Nombres',
          lastNames: 'Apellidos',
          ciPassport: 'Cédula de identidad / Pasaporte',
          nationality: 'Nacionalidad',
          gender: 'Género',
          birthdate: 'Fecha de nacimiento',
          placeOfBirth: 'Lugar de nacimiento',
          economicActivity: 'Actividad economica',
          specificActivity: 'Actividad especifica',
          occupation: 'Profesión / Ocupación',
          direction: 'Dirección',
          state: 'Estado',
          municipality: 'Municipio',
          parish: 'Parroquia',
          phone1: 'Telefono 1',
          phone2: 'Telefono 2',
          institutionReportingClient: 'Cliente de la institución reportante',
          riskLevel: 'Nivel de riesgo LC/FT/FPADM',
          employmentRelationship:
            'Relación laboral con la persona o institución reportante',
          businessName: 'Razón social',
          rif: 'Registro de información fiscal (RIF)',
          constitutionDate: 'Fecha de constitución',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
      case 'descriptionRas':
        keys = Object.keys(taskCase.data.othersInstruments[0]);
        status = {
          agency: 'Agencia',
        };
        llaves = Object.values(status);
        dataTable = [llaves];
        for (let el of taskCase.data.othersInstruments[0]) {
          let register = [];
          for (let value in keys) {
            if (el[keys[value]] === true) {
              el[keys[value]] = 'Si';
            } else if (el[keys[value]] === false) {
              el[keys[value]] = 'No';
            }
            register.push(el[keys[value]]);
          }
          dataTable.push(register);
        }

        delete taskCase.data.othersInstruments;
        keys = Object.keys(taskCase.data);
        status = {
          credit: 'Credito(s): que representen abono, ingreso o incremento',
          debit: 'Débito(s): Retiro, egreso o disminuición',
          description: 'Descripción de la actividad realizada *',
          otherPerson: 'Otras personas relacionadas en el reporte',
          category: 'Categoría especial de Riesgo',
          reportType: 'Tipo de reporte',
          typeDate: 'Fecha o rango de la operación *',
          date: 'Fecha (si se trata de una operacion especifica )',
          operationRef: 'Referencia de la operación',
          from: 'Desde',
          to: 'Hasta',
          currency: 'Monedas',
          typeOfCurrency: 'Moneda, Tilde el cuadro que corresponda',
          operationType: 'Tipo de operación',
          instrumentType: 'Tipo de instrumento o producto',
          instrumentNumber: 'Número del instrumento o producto',
          agency: 'Agencia de apertura',
          openingDate: 'Fecha de apertura',
          deadline: 'Fecha de cierre',
          instrumentDescription:
            'Descripción del instrumento o producto asociado a la operacion reportada',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          if (taskCase.data[keys[value]] === true) {
            taskCase.data[keys[value]] = 'Si';
          } else if (taskCase.data[keys[value]] === false) {
            taskCase.data[keys[value]] = 'No';
          }
          if (
            status[keys[value]] ==
            'Descripción del instrumento o producto asociado a la operacion reportada'
          ) {
            taskCase.data[keys[value]] =
              taskCase.data[keys[value]].instrumentType;
          }
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }

        break;
      // case "operationsAndInstrumentsRelatedToRAS":
      //   if (before.data != taskCase.data) {
      //     let ultimo = taskCase.data.othersInstruments;
      //     let ultimoBefore = before.data.othersInstruments;
      //     action = action + ` Actualizo la tabla`;
      // if (ultimoBefore.length < ultimo.length) {
      //   action =
      //     action +
      //     ` Agrego registro de montos cliente: ${
      //       taskCase.data.othersInstruments[ultimo.length - 1]
      //         .instrumentNumber
      //     }`;
      // } else if (ultimoBefore.length > ultimo.length) {
      //   action =
      //     action +
      //     ` elimino ${
      //       ultimoBefore.length - ultimo.length
      //     } registro de montos cliente`;
      // }
      // }
      // break;
      // case "peopleRelatedToTheRAS":
      //   if (before.data != taskCase.data) {
      //     action = action + ` Actualizo la tabla`;
      //   }
      //   break;
      case 'sucursalRas':
        keys = Object.keys(taskCase.data);
        status = {
          sucursal: 'Sucursal',
          telefono: 'Teléfonos de la Sucursal, Agencia o Lugar',
          direccion: 'Dirección de la Sucursal, Agencia o Lugar',
          estado: 'Estado',
          municipio: 'Municipio',
          parroquia: 'Parroquia',
        };
        llaves = Object.keys(status);
        for (let value in keys) {
          data.push({
            value: taskCase.data[keys[value]],
            key: llaves[value],
          });
        }
        break;
    }
    return { data, dataTable };
    //////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////
    //////////////////////////////////////////////////////////
  }
}
